import React from 'react';

const LoadingState = ({ message = 'Loading posts...' }) => {
  return (
    <div className="loading-state">
      <p>{message}</p>
    </div>
  );
};

export default LoadingState;
